import { WebApiService } from '../services/web-api-service';
import { autoinject } from 'aurelia-framework';
import { CarrierFilter } from '../models/carrier-filter';
import { Carrier } from '../models/carrier';

@autoinject()
export class CarriersController {
    constructor(private api: WebApiService) {
    }

    searchCarriers(filter:CarrierFilter): Promise<any> {
        filter = filter || new CarrierFilter();
        return this.api.get("Carriers", "SearchCarriers", filter);
    }

    getCarrierById(id: number): Promise<any> {
        return this.api.get("Carriers", "GetCarrierById", { carrierId: id });
    }

    printApplication(carrierId: number, carrierName: string): void {
        var parameters = {
            carrierId: carrierId,
            carrierName: carrierName
        };
        window.open(this.api.getUrl("Report", "CarrierBasicInfo", parameters));
    }


}
